export default {
	loading: 'Loading',
};
